module.exports = __webpack_public_path__ + "static/media/person2.9c521fd4.jpg";